"use client";

import { Divider } from "@heroui/divider";
import React from "react";

const WhatSetUsApart = () => {
  const ourValue = [
    {
      index: "01",
      title: "100% value",
      body: "Every hire delivers real impact, not just a filled role.",
    },
    {
      index: "02",
      title: "100% Peace of mind",
      body: "We handle the hiring process so you don’t have to worry.",
    },
    {
      index: "03",
      title: "Vetted Professionals",
      body: "Carefully screened for skill, mindset, and work readiness.",
    },
    {
      index: "04",
      title: "Indemnity",
      body: "Your business is protected if expectations aren’t met.",
    },
    {
      index: "05",
      title: "100% Cotton",
      body: "Every hire is selected to meet a trusted standard of quality.",
    },
  ];

  return (
    <section className="max-w-screen-2xl mx-auto lg:px-28 px-6 relative max-sm:px-4 max-sm:pb-10 max-sm:pt-16 pb-11">
      <div className="grid grid-cols-5 max-lg:grid-cols-3 max-sm:grid-cols-1 max-sm:gap-6 ">
        {ourValue.map((val, index) => (
          <div
            key={index}
            className="flex py-4 gap-4 max-sm:py-0 max-sm:gap-3"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <Divider
              className="max-sm:hidden dark:bg-foreground-200"
              orientation="vertical"
            />

            <div>
              <div className="mb-[83px] text-foreground dark:text-foreground-600 text-xs font-normal leading-4 tracking-[0.48px] uppercase font-mono max-sm:mb-4">
                {val.index}
              </div>

              <div>
                <div className="mb-3 text-neutral-950 dark:text-foreground-950 text-base font-medium leading-6 tracking-[-0.176px] max-sm:text-sm">
                  {val.title}
                </div>

                <div className="text-neutral-500 dark:text-foreground-600 text-sm font-normal leading-5 tracking-[-0.084px] max-sm:text-xs">
                  {val.body}
                </div>
              </div>
            </div>

            {index == ourValue.length - 1 && (
              <Divider
                className="max-sm:hidden dark:bg-foreground-200"
                orientation="vertical"
              />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhatSetUsApart;
